import type { Component } from 'solid-js'

type Props = {
  onStart: () => void
}

/**
 * ブラウザの自動再生制限で放送が始まらないときだけ出す。
 * 再生が始まったら消えるので、通常の視聴中に Player を覆うことはない。
 */
export const StartOverlay: Component<Props> = (props) => (
  <button
    type="button"
    onClick={props.onStart}
    class="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-ch-bg/80 backdrop-blur-sm"
  >
    <span class="flex size-14 items-center justify-center rounded-full border border-ch-border bg-ch-elevated text-xl">
      ▶
    </span>
    <span class="text-sm font-semibold tracking-wide">834CH をつける</span>
    <span class="text-xs text-ch-dim">放送中の位置から再生します</span>
  </button>
)
